import BaseModel from './BaseModel';

class UserModel extends BaseModel {

    //These have to match with the routes in backend > APIController
    static USERS_REGISTER = 'users-register';
    static USERS_AUTH = 'users-auth';

    constructor() {
        super();
    }

    async register(params) {
        return await this.saveData(UserModel.USERS_REGISTER, params);
    }

    async authenticate(params) {
        return await this.postData(UserModel.USERS_AUTH, params);
    }
}

export default UserModel;
